import React, { Component } from 'react';
import {Helmet} from "react-helmet";

class FavIcon extends Component {

  render() {
    if (this.props.isKNVB) {
      return (
          <Helmet>
            <link rel="icon" type="image/png" sizes="32x32" href="/favicon-knvb/favicon-32x32.png" />
            <link rel="icon" type="image/png" sizes="16x16" href="/favicon-knvb/favicon-16x16.png" />
            <link rel="manifest" href="/favicon-knvb/manifest.json" />
            <link rel="mask-icon" href="/favicon-knvb/safari-pinned-tab.svg" color="#5bbad5" />
          </Helmet>);
    }
    return (
      <Helmet>
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
        <link rel="manifest" href="/favicon/manifest.json" />
        <link rel="mask-icon" href="/favicon/safari-pinned-tab.svg" color="#5bbad5" />
      </Helmet>);
  }
}

export default FavIcon;



// WEBPACK FOOTER //
// ./src/app/FavIcon.jsx